import { Notice } from './Notice';
import DuplicateReg2ConfirmationModal from './DuplicateReg2ConfirmationModal';
import { DuplicateReg2FormModal } from './DuplicateReg2FormModal';

export {
  DuplicateReg2ConfirmationModal,
  DuplicateReg2FormModal,
  Notice,
}
